import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var UiMenuDots3HIcon16Regular = forwardRefAndName('UiMenuDots3HIcon16Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 16
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M1.75 8a1.248 1.248 0 1 0 2.497 0A1.248 1.248 0 0 0 1.75 8Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M8 9.248a1.248 1.248 0 1 1 0-2.496 1.248 1.248 0 0 1 0 2.496Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M13.002 9.248a1.248 1.248 0 1 1 0-2.496 1.248 1.248 0 0 1 0 2.496Z"
    }))
  );
});